/* Open all PDF links in a new window */
document.querySelectorAll('a').forEach((linkElem: Element, index) => {
	if (linkElem.hasAttribute('href') && linkElem.getAttribute('href').endsWith('.pdf')) {
		linkElem.setAttribute('target', '_blank');
	}
});

/* mailencrypting */
setTimeout(function () {
	let mailElement = document.querySelectorAll('[data-madr1]:not(.madr-done)');

	mailElement.forEach((mail: HTMLElement, index) => {
		const maddr = mail.getAttribute('data-madr1') + '@' + mail.getAttribute('data-madr2') + '.' + mail.getAttribute('data-madr3');
		const linktext = mail.getAttribute('data-linktext') ? mail.getAttribute('data-linktext') : maddr;

		const a = document.createElement('a')
		a.setAttribute('href', `mailto:${maddr}`)
		a.innerHTML = linktext;

		if (mail.parentElement) mail.parentElement.appendChild(a);
		mail.classList.add('madr-done');
		mail.style.display = 'none';
	});
}, 500);

/* Go to top button */
if (document.querySelector('#to-shine-to-top')) {
	document.querySelector('#to-shine-to-top').addEventListener('click', (e) => {
		e.preventDefault();

		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	})
}

/* scrolling behavior (to top button / breadcrumb) */
const navheader = document.querySelector('#to-shine-page-navigation') as HTMLElement;
const navheight = navheader.offsetHeight;
window.addEventListener('scroll', function (event) {
	// const bc = document.querySelector('.to-shine-page-breadcrumb');
	// if(bc != null) {
	// 	(bc as HTMLElement).style.top = `${navheader.offsetHeight - 1}px` ;

	// 	if (window.scrollY > navheight) {
	// 		bc.classList.add('bg-light' , 'shadow');
	// 	} else {
	// 		bc.classList.remove('bg-light' , 'shadow');
	// 	}
	// }

	const toTop = document.querySelector("#to-shine-to-top");
	if (toTop != null) {
		/* show / hide scroll to top button */
		if (window.scrollY > 200) {
			toTop.classList.add('to-shine-top-visible');
		} else {
			toTop.classList.remove('to-shine-top-visible');
		}
	}

}, false);

/* === Breadcrumb === */
const bc = document.querySelector('.to-shine-page-breadcrumb');
if (bc) {
	const bcALast = document.querySelector('.to-shine-page-breadcrumb span a:last-child');
	if (bcALast) bcALast.classList.add('last');

	const bcSpanLast = document.querySelector('.to-shine-page-breadcrumb span:last-child')
	if (bcSpanLast) bcSpanLast.classList.add('last');

	const bcSpanLinkChild = document.querySelector('.to-shine-page-breadcrumb span .to-shine-page-breadcrumb-link:nth-last-child(3)');
	if (bcSpanLinkChild) bcSpanLinkChild.classList.add('second-last');

	// Manually add aria-current attribute to last breadcrumb
	const bcCurrent = document.querySelectorAll('.to-shine-page-breadcrumb-link');
	if (bcCurrent) {
		let bcLinks = Array.from(bcCurrent);
		let bcLastLink = bcLinks[bcLinks.length - 1];
		let bcCurrentPage = bcLastLink;

		bcCurrentPage.setAttribute("aria-current", "page");
	}
}

/* === Header Images === */
// Manually build array of generic background images.
// const headerImages = [
// 	"Graham_Hills_2000x600.jpg",
// 	"TIC-1.jpg",
// 	"xFaculty-of-Science---Day-3.jpg.pagespeed.ic.Cu8Dj8wB3p.webp",
// 	"xSIPBS-2000x600.jpg.pagespeed.ic.8KZA4nHX6X.webp",
// 	"xstrathclyde-business-school.jpg.pagespeed.ic.Okj5oxHuqP.webp",
// 	"xtic-building.jpg.pagespeed.ic.-oRuXJOxFy.webp",
// 	"xWhy_Choose_Strathclyde_1600x600-min.jpg.pagespeed.ic.kuvPPREreZ.webp",
// 	"xYoung_man_works_on_laptop_and_takes_notes_1600x600.jpg.pagespeed.ic.mY5BI61DCd.webp",
// ]

// // Pick random image.
// let headerImage = headerImages[(Math.floor(Math.random() * (headerImages.length)))];

// // Find header image element.
// let image = document.querySelector('.page-banner__image');

// // Update image src attribute with path to image folder, plus the random image.
// image.setAttribute("src", `/Portals/_default/skins/strathclyde-external-dnn-theme/images/${headerImage}`);


/**
 * JS customized
 */

import ImageLazyLoad from './almuni/ImageLazyLoad';
import TableSorter from './almuni/TableSorter';

export const EWDS = (() => {
	'use strict';

	const DEBUG_MODE: boolean = true;
	globalThis.EWDS_DEBUG = DEBUG_MODE;

	/**
	 * Perform initialisation
	 */
	function init() {

		// Initialise ImageLazyLoad
		ImageLazyLoad.init();

		// Initialise TableSorter
		TableSorter.init();

	}

	/**
	 * Expose private methods or properties
	 */
	return {
		init: init
	};

})();

document.onreadystatechange = function () {

	if (document.readyState == "complete") {

		const EWDSInit = setTimeout(EWDS.init, 1000);

	}
}
